// Copyright 2015-2021 Swim inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import {Lazy} from "@swim/util";
import {WarpClient, client} from "@swim/client";
import type {Model} from "../Model";
import {ModelManager} from "../manager/ModelManager";
import type {WarpManagerObserver} from "./WarpManagerObserver";

export class WarpManager<M extends Model = Model> extends ModelManager<M> {
  constructor(client: WarpClient) {
    super();
    Object.defineProperty(this, "client", {
      value: client,
      enumerable: true,
      configurable: true,
    });
  }

  readonly client!: WarpClient;

  override readonly modelManagerObservers!: ReadonlyArray<WarpManagerObserver>;

  @Lazy
  static global<M extends Model>(): WarpManager<M> {
    return new WarpManager(client);
  }
}
